/* Copyright (c) 2026. Amazon.com, Inc. or its affiliates. All rights reserved. */

export const podcastPages = {
    Podcasts: () => import('@/podcasts/Podcasts'),
    PodcastCategoryPage: () => import('@/podcasts/PodcastCategoryPage'),
    PodcastEpisodePage: () => import('@/podcast/PodcastEpisodePage'),
    PodcastPagesPage: () => import('@/podcasts/PodcastPagesPage'),
    PodcastProviderPage: () => import('@/podcasts/PodcastProviderPage'),
    PodcastSeeMorePage: () => import('@/podcast/PodcastSeeMorePage'),
    PodcastShowDetailPage: () => import('@/podcast/PodcastShowDetailPage'),
    TopPodcastsPage: () => import('@/podcast/TopPodcastsPage'),
}
